let mapInstance = null

export default {
  init(key) {
    return new Promise((resolve) => {
      if (!window.google) {
        const script = document.createElement('script')
        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}`
        script.onload = resolve
        document.head.appendChild(script)
      } else {
        resolve()
      }
    })
  },

  showLocation(address) {
    if (mapInstance) {
      new window.google.maps.Map(document.getElementById('map'), {
        center: { lat: 24.7136, lng: 46.6753 }, // 利雅得坐标
        zoom: 15
      })
    }
  }
}